import {ErrorMessages} from 'constants/Errors';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {getDashboardData} from 'services/admin-data';
import {getPubDashboardData} from 'services/pubs';
import DashboardData from 'typescript/models/AdminDashboardData';
import {ManagerDashboardData} from 'typescript/models/ManagerDashboardData';

import {getManagerDashboardDataACS, setAdminDashboardDataAC, setErrorAC, setManagerDashboardDataAC} from '../appSlice';
import {handleError} from '../error/saga';

export function* getAdminDashboardCount() {
  try {
    const response: AxiosResponse<DashboardData> = yield call(getDashboardData);

    yield put(setAdminDashboardDataAC(response.data));
  } catch (error) {
    yield put(setErrorAC(ErrorMessages.DASHBOARD_DATA));
  }
}

export function* getManagerDashboardData(action: ReturnType<typeof getManagerDashboardDataACS>) {
  try {
    const response: AxiosResponse<ManagerDashboardData> = yield call(getPubDashboardData, action.payload);

    yield put(setManagerDashboardDataAC(response.data));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.DASHBOARD_DATA);
  }
}
